import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './simple-image.scss.js';
import { getStyleClassNames, sizeClasses } from '../../utilities/constants/styles.constants.js';

class SimpleImage extends s {
    constructor() {
        super(...arguments);
        this.isRtl = false;
        this.padding = '1em';
        this.marginBottom = '0.5em';
        this.forceWideAspect = true;
        this.borderRadius = '0.5em';
        this.imageSize = 'Default';
        this.additionalClasses = '';
    }
    render() {
        const imgClassNames = getStyleClassNames({
            padding: this.padding,
            marginBottom: this.marginBottom,
            borderRadius: this.borderRadius,
            forceWideAspect: this.forceWideAspect,
        });
        const isRtlClass = this.isRtl ? 'text-align-right' : '';
        const sizeClass = this.imageSize ? sizeClasses[this.imageSize] : '';
        return x `<div class="simple-image ${sizeClass} ${this.additionalClasses} ${isRtlClass}"><img class="${imgClassNames}" src="${this.imageSrc}" alt=""></div>`;
    }
}
SimpleImage.styles = css_248z;
__decorate([
    n({ type: Boolean })
], SimpleImage.prototype, "isRtl", void 0);
__decorate([
    n({ type: String })
], SimpleImage.prototype, "imageSrc", void 0);
__decorate([
    n({ type: String })
], SimpleImage.prototype, "padding", void 0);
__decorate([
    n({ type: String })
], SimpleImage.prototype, "marginBottom", void 0);
__decorate([
    n({ type: Boolean })
], SimpleImage.prototype, "forceWideAspect", void 0);
__decorate([
    n({ type: String })
], SimpleImage.prototype, "borderRadius", void 0);
__decorate([
    n({ type: String })
], SimpleImage.prototype, "imageSize", void 0);
__decorate([
    n({ type: String })
], SimpleImage.prototype, "additionalClasses", void 0);
customElements.define('simple-image', SimpleImage);

export { SimpleImage };
